import { render, staticRenderFns } from "./feeSetting.vue?vue&type=template&id=6e0828b3&scoped=true"
import script from "./feeSetting.vue?vue&type=script&lang=js"
export * from "./feeSetting.vue?vue&type=script&lang=js"
import style0 from "./feeSetting.vue?vue&type=style&index=0&id=6e0828b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0828b3",
  null
  
)

export default component.exports